import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/App";
import { useAuthStore } from "@/shared/lib/auth-store";

import "@/index.css";

// Гидратируем auth-стор из localStorage до первого рендера —
// иначе ProtectedRoute моргнёт редиректом на /login при перезагрузке.
useAuthStore.getState().hydrate();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
